<template>
  <div class="NavTop">
    <div style="justify-content:left"><van-icon name="arrow-left" @click="clickBack" class="nav-icon"/></div>
    <div>{{Title}}</div>
    <div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginTop",
  props:['Title'],
  methods:{
    clickBack(){
      // history.back()
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped lang="scss">
  .NavTop{
    height: 12.889vw;
    background-color: white;
    display: flex;
    div{
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 4.444vw;
    }
    .nav-icon {
      font-size: 5vw; /* 根据需要调整图标大小 */
      color: rgb(150, 151, 153); /* 图标颜色可以根据需要调整 */
      cursor: pointer;
      margin-left: 5vw;
    }
  }
</style>
